import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useTypedTheme } from '@monorepo-web/styles';
import { useIsMobile } from '@monorepo-web/utils';
export default function Breadcrumb({ screen }) {
    const isMobile = useIsMobile();
    const { search, pathname } = useLocation();
    const theme = useTypedTheme();
    const breadcrumbs = [
        _jsx(Link, Object.assign({ style: { textDecoration: 'none', color: 'inherit' }, to: { pathname: '/', search }, state: pathname }, { children: "Home" }), "1"),
        _jsx(Typography, Object.assign({ color: "inherit", sx: { fontSize: isMobile ? theme.smFontSize : theme.mdFontSize } }, { children: screen }), "2"),
    ];
    return (_jsx(Breadcrumbs, Object.assign({ sx: { color: theme.fontColor, fontSize: isMobile ? theme.smFontSize : theme.mdFontSize }, separator: ">" }, { children: breadcrumbs })));
}
